import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Category = () => {
  const { id } = useParams();
  const [properties, setProperties] = useState([]);
  const [categoryName, setCategoryName] = useState('');

  useEffect(() => {
    fetchProperties(id);
  }, [id]);

  const fetchProperties = async (categoryId) => {
    try {
      const response = await fetch(`https://dayoffice24.it/api/property/category-id/${categoryId}`);
      const data = await response.json();
      console.log('Fetched Data:', data);
      if (data && data.success && data.data) {
        setProperties(data.data);
        setCategoryName(data.data[0]?.category?.category_name || '');
      } else {
        console.error('Error fetching property data:', data);
      }
    } catch (error) {
      console.error('Error fetching property data:', error);
    }
  };

  return (
    <div className="main_wrap">
      <Header />
      <div className="content-wrapper">
        

        <div className="breadcrumb-wrap bg-f br-2"> 
          <div className="container">
            <div className="breadcrumb-title text-center">
              <h2>{categoryName}</h2> 
              <ul className="breadcrumb-menu list-style">
                <li><Link to="/">Home</Link></li>
                <li>{categoryName}</li> 
              </ul>
            </div> 
          </div>
        </div> 


        <section className="listing-wrap ptb-100">
          <div className="container">
            <div className="row">
              {properties.map((property) => (
                <div className="col-xl-4 col-lg-6 col-md-6" key={property._id}>
                  <div className="property-card style4">
                    <div className="property-img">
                      <Link to={`/PropertyView/${property._id}`}><img src={property.thumb_image} alt={property.property_name} /></Link>
                       <span className="property-status">{property.property_type}</span>
                    </div>
                    <div className="property-info">
                      <h3>
                        <Link to={`/PropertyView/${property._id}`}>{property.property_name}</Link>
                      </h3>
                       <p>{property.availableDates.view_date}</p>
                      <p>
                        <i className="flaticon-location"></i>
                        {property.address}
                      </p>
                      {/* Render other property information */}
                      <ul className="property-metainfo list-style">
                        <li>
                          <i className="flaticon-user-avatar"></i>
                          {property.no_of_guest}
                        </li>
                        <li>
                          <i className="flaticon-bath-tub"></i>
                          {property.bathrooms}
                        </li>
                        <li>
                          <i className="flaticon-square"></i>
                          {property.property_size} sqft
                        </li>
                      </ul>
                      <p className="property-price">
                        €{property.price}/<span>{property.price_charge_type}</span>
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default Category;
